import request from '../request';

type RequestData = {
  accountId: string;
  idToken: string;
};

const getBookings = async (body: RequestData) => {
  await request({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/accounts/${body?.accountId}`,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${body?.idToken}`,
    },
  });
};

export default getBookings;
